import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "../Admregister/Admregister.css";
import axios from "../../utils/axiosConfig";
import schoolLogo from "../../assets/images/npw-logo.png";

const Admregister = () => {

  const [captcha, setCaptcha] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [classes, setClasses] = useState([]);

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    birthdate: "",
    gender: "",
    className: "",
    remark: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setShowModal(true);

    axios.get("/api/classes")
      .then((res) => {
        setClasses(res.data);
      })
      .catch((err) => {
        console.error("Error fetching classes:", err);
      });

  }, []);

  const handleClose = () => setShowModal(false);

  const validate = () => {
    let newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full Name is required";
    }

    if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter valid 10-digit number";
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter valid email";
    }

    if (!formData.birthdate) {
      newErrors.birthdate = "Select birthdate";
    }

    if (!formData.gender) {
      newErrors.gender = "Select gender";
    }

    if (!formData.className) {
      newErrors.className = "Select class";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "fullName") {
      value = value.toUpperCase();
    }

    if (name === "phone") {
      value = value.replace(/[^0-9]/g, "").slice(0, 10);
    }

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captcha) {
      alert("Please verify captcha");
      return;
    }

    if (validate()) {
      try {
        await axios.post("/api/admission", {
          ...formData,
          captcha: captcha
        });

        alert("Application Submitted Successfully ✅");
        setShowModal(false);

      } catch (error) {
        console.error("Submit Error:", error);
        alert("Error submitting form ❌");
      }
    }
  };

  if (!showModal) return null;

  return (
    <div className="adm-overlay">

      <div className="adm-modal">

        <button className="adm-close" onClick={handleClose}>
          &times;
        </button>

        <div className="adm-left">
          <div className="adm-left-overlay">
            <img src={schoolLogo} alt="logo" className="adm-logo" />
            <h3>Future Begins Here...</h3>
            <p>Begin your child’s learning journey with us.</p>
          </div>
        </div>

        <div className="adm-right">

          <h4 className="adm-title">Enquiry For Admission</h4>

          <form className="adm-form" onSubmit={handleSubmit}>

            <div className="adm-field adm-fullname">
              <label>Full Name</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
              />
              {errors.fullName && <span className="adm-error">{errors.fullName}</span>}
            </div>

            <div className="adm-grid">
              <div className="adm-field">
                <label>Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {errors.phone && <span className="adm-error">{errors.phone}</span>}
              </div>

              <div className="adm-field">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <span className="adm-error">{errors.email}</span>}
              </div>
            </div>

            <div className="adm-grid">
              <div className="adm-field">
                <label>Date of Birth</label>
                <input
                  type="date"
                  name="birthdate"
                  value={formData.birthdate}
                  onChange={handleChange}
                />
                {errors.birthdate && <span className="adm-error">{errors.birthdate}</span>}
              </div>

              <div className="adm-field">
                <label>Gender</label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option>Male</option>
                  <option>Female</option>
                </select>
                {errors.gender && <span className="adm-error">{errors.gender}</span>}
              </div>
            </div>

            <div className="adm-field">
              <label>Class</label>
              <select
                name="className"
                value={formData.className}
                onChange={handleChange}
              >
                <option value="">Select Class</option>

                {classes.length > 0 ? (
                  classes.map((cls) => (
                    <option key={cls.id} value={cls.class_name}>
                      {cls.class_name}
                    </option>
                  ))
                ) : (
                  <option disabled>Loading...</option>
                )}
              </select>

              {errors.className && (
                <span className="adm-error">{errors.className}</span>
              )}
            </div>

            <div className="adm-field">
              <label>Remark</label>
              <textarea
                name="remark"
                value={formData.remark}
                onChange={handleChange}
              />
            </div>

            {/* ✅ FIXED HORIZONTAL CAPTCHA + BUTTON */}
            <div className="adm-bottom-horizontal">

              <div className="captcha-wrapper">
                <ReCAPTCHA
                  sitekey="6Lf7oNMsAAAAAETiWwBj-narLfqUej71jqWTPnBW"
                  onChange={(value) => setCaptcha(value)}
                />
              </div>

              <button type="submit" className="adm-submit">
                Submit Enquiry
              </button>

            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default Admregister;